"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemovableAttachments = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _generalStore = require("general-store");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _immutable = require("immutable");

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _EngagementAttachmentsDependency = _interopRequireDefault(require("crm_ui/attachments/data/EngagementAttachmentsDependency"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _AttachmentThumbnailUrlConfig = _interopRequireDefault(require("customer-data-communicator/data/attachments/AttachmentThumbnailUrlConfig"));

var _AttachmentsList = _interopRequireDefault(require("customer-data-email/components/attachments/AttachmentsList"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var EngagementsActions = _interopRequireWildcard(require("crm_data/engagements/EngagementsActions"));

var EngagementAttachmentsDependencyProps = {
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default).isRequired
};
var propTypes = (0, _extends2.default)({}, EngagementAttachmentsDependencyProps, {
  attachments: _reactImmutableProptypes.default.list.isRequired,
  canEdit: _propTypes.default.bool
});
var dependencies = {
  attachments: _EngagementAttachmentsDependency.default
};

var RemovableAttachments =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RemovableAttachments, _PureComponent);

  function RemovableAttachments(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RemovableAttachments);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RemovableAttachments).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RemovableAttachments, [{
    key: "handleRemoveAttachment",
    value: function handleRemoveAttachment(attachmentId) {
      var engagement = this.props.engagement;
      var updatedEngagementAttachments = engagement.get('attachments').filter(function (attachment) {
        return attachment.get('id') !== attachmentId;
      });
      return EngagementsActions.updateEngagementAttachments(engagement, (0, _immutable.Map)({
        attachments: updatedEngagementAttachments
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          engagement = _this$props.engagement,
          canEdit = _this$props.canEdit,
          attachments = _this$props.attachments;

      if (!engagement) {
        return null;
      }

      return _react.default.createElement(_AttachmentsList.default, {
        useDefaultPadding: false,
        hasInteractions: true,
        optionRemoveWithModal: true,
        childClassName: "p-left-0 p-right-2",
        attachments: attachments,
        onAttachmentRemoved: canEdit && this.handleRemoveAttachment,
        thumbnailUrlConfig: _AttachmentThumbnailUrlConfig.default
      });
    }
  }]);
  return RemovableAttachments;
}(_PureComponent2.default);

exports.RemovableAttachments = RemovableAttachments;
RemovableAttachments.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(RemovableAttachments);

exports.default = _default;